import React, { useState } from "react";
import * as styled from "./ScheduleGrid.styled";
import { FaTrash } from "react-icons/fa";

function ScheduleGrid({
  daysOfWeek,
  lessons,              // масив { day, hour, minute, name, time, type }
  handleLessonClick,
  resheduleLesson,
  setSelectedCell,
  setSelectedLesson,
  teacher,
  onDeleteSlot
}) {
  const [interval, setInterval] = useState(60); // 60 або 30 хв

  // Генеруємо timeSlots залежно від інтервалу
  const timeSlots = Array.from(
    { length: (24 * 60) / interval },
    (_, idx) => {
      const totalMin = idx * interval;
      const hour = Math.floor(totalMin / 60);
      const minute = totalMin % 60;
      const label = `${hour.toString().padStart(2, "0")}:${minute
        .toString()
        .padStart(2, "0")}`;
      return { hour, minute, label };
    }
  );

  const dayNameMapping = {
    Пн: "monday",
    Вт: "tuesday",
    Ср: "wednesday",
    Чт: "thursday",
    Пт: "friday",
    Сб: "saturday",
    Нд: "sunday"
  };

  // Знайти слот (розкладку) викладача
  const getSlotInfo = (dayIdx, slot) => {
    const rusDay = daysOfWeek[dayIdx];
    const engDay = dayNameMapping[rusDay];
    return teacher.slots?.find(s => 
      s.day === engDay && s.time === slot.label
    );
  };

  const handleCellClick = (dayIdx, slot) => {
    setSelectedCell({ day: dayIdx, hour: slot.hour, minute: slot.minute });
    resheduleLesson(dayIdx, slot.hour, slot.minute);
  };

  const handleDeleteSlot = (dayIdx, slot, e) => {
    e.stopPropagation();
    const info = getSlotInfo(dayIdx, slot);
    if (info && onDeleteSlot) onDeleteSlot(info);
  };

  return (
    <>
      {/* Перемикач інтервалу */}
      <styled.ToggleWrapper>
        <styled.ToggleButton
          active={interval === 60}
          onClick={() => setInterval(60)}
        >
          60 хв
        </styled.ToggleButton>
        <styled.ToggleButton
          active={interval === 30}
          onClick={() => setInterval(30)}
        >
          30 хв
        </styled.ToggleButton>
      </styled.ToggleWrapper>

      <styled.ScheduleGrid>
        {/* Заголовки днів */}
        <styled.GridHour>
          <styled.HourLabel>Час</styled.HourLabel>
          {daysOfWeek.map((d, i) => (
            <styled.HourLabel key={i}>{d}</styled.HourLabel>
          ))}
        </styled.GridHour>

        {/* Рядки часу */}
        {timeSlots.map((slot, rowIdx) => (
          <styled.GridHour key={rowIdx}>
            <styled.HourLabel>{slot.label}</styled.HourLabel>

            {daysOfWeek.map((_, dayIdx) => {
              // Відбираємо уроки, що починаються в цьому слоті
              const lessonsInCell = lessons.filter(lesson =>
                lesson.day === dayIdx &&
                lesson.hour === slot.hour &&
                lesson.minute >= slot.minute &&
                lesson.minute < slot.minute + interval
              );

              const slotInfo = getSlotInfo(dayIdx, slot);
              const bgColor = slotInfo
                ? slotInfo.type === "new-student" ? "#a0e7a0" : "#a0c4e7"
                : "initial";

              return (
                <styled.GridCell
                  key={dayIdx}
                  onClick={() => handleCellClick(dayIdx, slot)}
                  style={{ backgroundColor: bgColor }}
                >
                  {/* Кнопка видалення слота */}
                  {slotInfo && (
                    <styled.DeleteSlotButton
                      onClick={e => handleDeleteSlot(dayIdx, slot, e)}
                    >
                      <FaTrash size={10} />
                    </styled.DeleteSlotButton>
                  )}

                  {/* Карточки уроків */}
                  {lessonsInCell.map(lesson => {
                    // обчислюємо відступ від початку слоту:
                    const offsetPercent =
                      ((lesson.minute - slot.minute) / interval) * 100;

                    return (
                      <styled.LessonCard
                        key={`${lesson.name}-${lesson.time}`}
                        onClick={e => {
                          e.stopPropagation();
                          if (lesson.type === "cancel") return;
                          handleLessonClick(lesson);
                          setSelectedCell(null);
                          setSelectedLesson?.(lesson);
                        }}
                        style={{ top: `${offsetPercent}%` }}
                        istrial={lesson.type === "Trial"}
                        isreschedule={lesson.type === "Reschedule Lesson"}
                        issubstitute={lesson.type === "Substitute"}
                        iscancel={lesson.type === "cancel"}
                      >
                        <styled.StudentName>{lesson.name}</styled.StudentName>
                        <styled.LessonTime>{lesson.time}</styled.LessonTime>
                      </styled.LessonCard>
                    );
                  })}
                </styled.GridCell>
              );
            })}
          </styled.GridHour>
        ))}
      </styled.ScheduleGrid>
    </>
  );
}

export default ScheduleGrid;
